/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarkNotificationAsReadResponse } from '../../models/mark-notification-as-read-response';

export interface NotificationServiceMarkNotificationAsRead$Params {
  userUuid: string;
  notificationId: string;
  discordId?: string;
}

export function notificationServiceMarkNotificationAsRead(http: HttpClient, rootUrl: string, params: NotificationServiceMarkNotificationAsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<MarkNotificationAsReadResponse>> {
  const rb = new RequestBuilder(rootUrl, notificationServiceMarkNotificationAsRead.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('notificationId', params.notificationId, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarkNotificationAsReadResponse>;
    })
  );
}

notificationServiceMarkNotificationAsRead.PATH = '/api/v3/gateway/user/{userUuid}/notification/{notificationId}/read';
